// Import the Axios library for making asynchronous requests
import axios from 'axios'

class Search {
	// 1. Describe and create/initiate our object
	constructor() {
		this.addSearchHTML()
		this.resultsDiv = document.querySelector('#search-overlay__results')
		this.openButton = Array.from(document.querySelectorAll('.js-search-trigger'))
		this.closeButton = document.querySelector('.search-overlay__close')
		this.searchOverlay = document.querySelector('.search-overlay')
		this.searchField = document.querySelector('#search-term')
		this.clickOutside = document.querySelector('.search-overlay__wrapper')
		this.spinnerContainer = document.querySelector('.spinner-container')
		this.isOverlayOpen = false
		this.isSpinnerVisible = false
		this.previousValue
		this.typingTimer
		this.translations = {};
		this.setTranslations();
		this.events()
	}

	// 2. Events
	events() {
		// Attach click event listeners to open buttons
		this.openButton.forEach(el => {
			el.addEventListener('click', e => {
				e.preventDefault();
				this.openOverlay();
			});
		});

		// Attach click event listener to close button
		this.closeButton.addEventListener('click', () => this.closeOverlay());

		// Listen for keydown events on document
		document.addEventListener('keydown', e => this.keyPressDispatcher(e));

		// Listen for keyup events on the search field
		this.searchField.addEventListener('keyup', () => this.typingLogic());
	}

	// 3. Methods (function, action...)

	// Set the translations
	setTranslations() {
		if (typeof drlRoot.translations !== 'undefined') {
			this.translations = drlRoot.translations;
		}
	}

	// Function to handle typing logic
    handleClickOutside = (e) => {
        if (!this.openButton || !Array.isArray(this.openButton)) {
            console.warn("openButton is not defined or not an array.");
            return;
        }
    
        // Check if the click is outside all open buttons
        const isOutsideAllOpenButtons = !this.openButton.some(button => button.contains(e.target));
    
        // Check if the click is within the .sqzly-modal
        const isWithinSqzlyModal = e.composedPath().some(element => 
            element.classList && element.classList.contains('sqzly-modal')
        );
    
        // Proceed only if the click is outside open buttons and not within .sqzly-modal
        if (isOutsideAllOpenButtons && !isWithinSqzlyModal) {
            const withinBoundaries = this.clickOutside 
                ? e.composedPath().some(element => element === this.clickOutside) 
                : false;
    
            if (!withinBoundaries) {
                this.closeOverlay();
            }
        }
    }

	// Function to handle typing logic
	typingLogic() {
		// Check if the input value has changed
		if (this.searchField.value != this.previousValue) {
			// Clear any previous typing timer
			clearTimeout(this.typingTimer);

			// Check if there's a value in the search field
			if (this.searchField.value) {
				// Display spinner if not visible
				if (!this.isSpinnerVisible) {
					this.spinnerContainer.innerHTML = '<div class="spinner-loader"></div>';
					this.isSpinnerVisible = true;
				}

				// Set timer to fetch results after 750 milliseconds
				this.typingTimer = setTimeout(this.getResults.bind(this), 750);
			} else {
				// If search field is empty, clear results and add initial HTML structure
				this.addStartHTML()

				// Change spinner back to search icon and clear results
				this.spinnerContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/></svg>`;
				this.isSpinnerVisible = false;

				// Send datalayer event.
				if (typeof window.dataLayer !== 'undefined') {
					window.dataLayer.push({
						event : 'search_results',
						action: 'clear_search'
					});
				}
			}
		}

		// Store current value for comparison on next call
		this.previousValue = this.searchField.value;

		// Set href for "Show All" link to perform a default wp search
		// this.showAllLink.href = drlRoot.root_url + '/?s=' + encodeURIComponent(this.searchField.value);
	}

	async getResults() {
		try {
			// Make an asynchronous GET request using Axios to our custom endpoint
			const response = await axios.get(drlRoot.root_url + '/wp-json/drlsearch/v1/search?term=' + this.searchField.value)
			// Extract the response data from the API call
			const results = response.data

			// Update the HTML content of the results section based on received data
			this.resultsDiv.innerHTML = `
                <div class="tabset" id="panels"> 
                    <div class="tab-buttons">
                        <button class="tab-btn active" data-id="all" title="${this.translations.view_products}" >${this.translations.products} (${results.products.length })</button>
                        <button class="tab-btn" data-id="advice" title="${this.translations.view_advices}">${this.translations.advice} (${results.advice.length})</button>
                        <button class="tab-btn" data-id="blogs" title="${this.translations.view_blogs}">${this.translations.blogs} (${results.posts.length})</button>
                        <button class="tab-btn" data-id="pages" title="${this.translations.view_pages}">${this.translations.pages} (${results.pages.length})</button>
                    </div>
                    <div class="tab-panels">
                        <section id="all" class="tab-panel open">
                            <div class="tab-panel__wrapper">
                                <div class="tab-panel__left">
                                    <h2>${this.translations.products}</h2>
                                    ${results.products.length ? '<ul class="link-list">' : `<div class="no-results"><p><strong>${this.translations.no_products}</strong></p><p>${this.translations.adjust_query + ' ' + this.translations.products_page}</p></div>`}
                                    ${results.products.map(product => `
                                    <li>
                                        <div class="product ${product.type}">
                                            <div class="product__left">
                                                ${(product.discount_label_big ?? product.discount_label_small) ? `<div class="sale-label"><span class="top">${product.discount_label_big}</span><span class="bottom">${product.discount_label_small}</span></div>` : ''}
                                                <a href="${product.permalink}" class="img">
                                                    <img src="${product.image}" alt="${product.title}">
                                                </a>
                                            </div>
                                            <div class="product__middle">
                                                <div class="content">
                                                    <a href="${product.permalink}" class="title">${product.title}</a>
                                                    <p class="content__excerpt">${product.excerpt}</p>
                                                    <p>${product.in_stock ? `<span style="color:#006980;">${this.translations.in_stock}</span>` : `<span style="color:#F8485E;">${this.translations.out_of_stock}`}</span></p>
                                                    <p class="price">${product.price}</p>
                                                </div>
                                            </div>
                                            <div class="product__right">
                                                    ${product.in_stock ?
                                                        (product.type == 'variable' ?
                                                                `<a href="${product.permalink}" class="button add_to_cart_button ${product.type}" data-product_id="${product.id}" data-product_sku="${product.sku}" aria-label="Go to '${product.title}'" rel="nofollow" title="${this.translations.view_products}"><span class="add-now">${this.translations.view_options}</span></a>` :
                                                                `<button data-quantity="1" class="button add_to_cart_button product_type_simple ajax_add_to_cart" data-product_id="${product.id}" data-product_sku="${product.sku}" title="${this.translations.add_to_cart}"><span class="add-now" data-add="${this.translations.add_to_cart}" data-added="${this.translations.added}"></span></button>`
                                                        ) :
                                                        `<a href="${product.permalink}" class="button add_to_cart_button sold-out waitlist ${product.type}" data-product_id="${product.id}" data-product_sku="${product.sku}" aria-label="Go to '${product.title}'" rel="nofollow" title="${this.translations.waitlist}"><span class="add-now">${this.translations.waitlist}</span></a>`
                                                    }
                                                </div>
                                        </li>`).join('')}
                                    ${results.products.length ? '</ul>' : ''}
                                </div>
                                <div class="tab-panel__right">
                                    <h2>${this.translations.categories}</h2>
                                    ${results.products_cats.length ? '<ul class="link-list min-list">' : `<div class="no-results"><p><strong>${this.translations.no_categories}</strong></p><p>${this.translations.adjust_query + ' ' + this.translations.products_page}</p></div>`}
                                    ${results.products_cats.slice(0, 5).map(item => `<li><a href="${item.permalink}">${item.title}</a> ${item.postType == 'post' ? `by ${item.authorName}` : ''}</li>`).join('')}
                                    ${results.products_cats.length ? '</ul>' : ''}
                                    <hr>
                                    <h2>${this.translations.advice}</h2>
                                    ${results.advice.length ? '<ul class="link-list min-list">' : `<div class="no-results"><p><strong>${this.translations.no_advices}</strong></p><p>${this.translations.adjust_query + ' ' + this.translations.advices_page}</p></div>`}
                                    ${results.advice.slice(0, 5).map(item => `<li><a href="${item.permalink}">${item.title}</a> ${item.postType == 'post' ? `by ${item.authorName}` : ''}</li>`).join('')}
                                    ${results.advice.length ? '</ul>' : ''}
                                </div>
                            </div>
                        </section>
                        <section id="products" class="tab-panel">
                            <h2>${this.translations.products}</h2>
                            ${results.products.length ? '<ul class="link-list">' : `<div class="no-results"><p><strong>${this.translations.no_products}</strong></p><p>${this.translations.adjust_query + ' ' + this.translations.products_page}</p></div>`}
                            ${results.products.map(product => `
                                <li>
                                    <div class="product ${product.type}"> 
                                        <div class="product__left">
                                                ${(product.discount_label_big ?? product.discount_label_small) ? `<div class="sale-label"><span class="top">${product.discount_label_big}</span><span class="bottom">${product.discount_label_small}</span></div>` : ''}
                                            <a href="${product.permalink}" class="img">
                                                <img src="${product.image}" alt="${product.title}">
                                            </a>
                                        </div>
                                        <div class="product__middle">
                                            <div class="content">
                                                <a href="${product.permalink}" class="title">${product.title}</a>
                                                <p class="content__excerpt">${product.excerpt}</p>
                                                <p>${product.in_stock ? `<span style="color:#006980;">${this.translations.in_stock}</span>` : `<span style="color:#F8485E;">${this.translations.out_of_stock}`}</span></p>
                                                <p class="price">${product.price}</p>
                                                
                                            </div>
                                        </div>
                                        <div class="product__right">
                                                ${product.in_stock ?
                                                    (product.type == 'variable' ?
                                                            `<a href="${product.permalink}" class="button add_to_cart_button ${product.type}" data-product_id="${product.id}" data-product_sku="${product.sku}" aria-label="Go to '${product.title}'" rel="nofollow" title="${this.translations.view_products}"><span class="add-now">${this.translations.view_options}</span></a>` :
                                                            `<button data-quantity="1" class="button add_to_cart_button product_type_simple ajax_add_to_cart" data-product_id="${product.id}" data-product_sku="${product.sku}" title="${this.translations.add_to_cart}"><span class="add-now" data-add="${this.translations.add_to_cart}" data-added="${this.translations.added}"></span></button>`
                                                    ) :
                                                    `<a href="${product.permalink}" class="button add_to_cart_button sold-out waitlist ${product.type}" data-product_id="${product.id}" data-product_sku="${product.sku}" aria-label="Go to '${product.title}'" rel="nofollow" title="${this.translations.waitlist}"><span class="add-now">${this.translations.waitlist}</span></a>`
                                                }
                                            </div>
                                    </li>`).join('')}
                            ${results.products.length ? '</ul>' : ''}
                        </section>
                        <section id="categories" class="tab-panel">
                            <h2>${this.translations.categories}</h2>
                            ${results.products_cats.length ? '<ul class="link-list min-list">' : `<div class="no-results"><p><strong>${this.translations.no_categories}</strong></p><p>${this.translations.adjust_query + ' ' + this.translations.products_page}</p></div>`}
                            ${results.products_cats.map(item => `<li><a href="${item.permalink}">${item.title}</a> ${item.postType == 'post' ? `by ${item.authorName}` : ''}</li>`).join('')}
                            ${results.products_cats.length ? '</ul>' : ''}
                        </section>
                        <section id="advice" class="tab-panel">
                            <h2>${this.translations.advice}</h2>
                            ${results.advice.length ? '<ul class="link-list">' : `<div class="no-results"><p><strong>${this.translations.no_advices}</strong></p><p>${this.translations.adjust_query + ' ' + this.translations.advices_page}</p></div>`}
                            ${results.advice.map(advice => `<li>
                                <div class="post">
                                    <div class="post__left">
                                        <a href="${advice.permalink}" class="img">
                                            <img src="${advice.image}" alt="${advice.title}">
                                        </a>
                                    </div>
                                    <div class="post__right">
                                        <div class="content">
                                            <a href="${advice.permalink}" class="title">${advice.title}</a>
                                            <p>${advice.excerpt}</p>
                                            <a href="${advice.permalink}">${this.translations.read_more}</a>
                                        </div>
                                    </div>
                                </div>
                            </li>`).join('')}
                            ${results.advice.length ? '</ul>' : ''}
                        </section>
                        <section id="blogs" class="tab-panel">
                            <h2>${this.translations.blogs}</h2>
                            ${results.posts.length ? '<ul class="link-list">' : `<div class="no-results"><p><strong>Geen blogs</strong></p><p>${this.translations.adjust_query + ' ' + this.translations.advices_page}</p></div>`}
                            ${results.posts
								.map(
									post => `<li>
										<div class="post">
											<div class="post__left">
												<a href="${post.permalink}" class="img">
													<img src="${post.image}" alt="${post.title}">
												</a>
											</div>
											<div class="post__right">
												<div class="content">
													<a href="${post.permalink}" class="title">${post.title}</a>
													<p>${post.excerpt}</p>
													<a href="${post.permalink}">${this.translations.read_more}</a>
												</div>
											</div>
										</div> 
									</li>`
								)
								.join('')}
                            ${results.posts.length ? '</ul>' : ''}
                        </section>
                        <section id="pages" class="tab-panel">
                            <h2>${this.translations.pages}</h2>
                            ${results.pages.length ? '<ul class="link-list min-list">' : `<div class="no-results"><p><strong>Geen blogs</strong></p><p>${this.translations.adjust_query + ' ' + this.translations.advices_page}</p></div>`}
                            ${results.pages.map(page => `<li><a href="${page.permalink}">${page.title}</a> ${page.postType == 'post' ? `by ${page.authorName}` : ''}</li>`).join('')}
                            ${results.pages.length ? '</ul>' : ''}
                        </section>
                    </div>
                </div>`

			// Change the spinner icon back to the search icon once results are loaded
			this.spinnerContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" id="clearSearch" class="bi bi-trash3" viewBox="0 0 16 16"><path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"/></svg>`
			this.isSpinnerVisible = false

			// Add event listener to clear search button
			document.getElementById('clearSearch').addEventListener('click', () => {
				this.searchField.value = '';
				this.searchField.focus();
				this.addStartHTML();
				this.spinnerContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/></svg>`
			});

			// Fire GTM datalayer.
			if (typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push({
					event      : 'view_search_results',
					search_term: this.searchField.value
				});
			}

            // Attach click event listener to tab buttons
		    this.switchTab()
		} catch (e) {
			// Log any errors that occur during fetching
			console.log(e)
		}
	}

	// Function to handle key press events
	keyPressDispatcher(e) {
		// Open the overlay if 'S' (83) or 'Z' (90) is pressed, the overlay is not open, and the active element is not an input or textarea
		if ((e.keyCode == 83 || e.keyCode == 90) && !this.isOverlayOpen && document.activeElement.tagName != 'INPUT' && document.activeElement.tagName != 'TEXTAREA') {
			this.openOverlay();
		}

		// Close the overlay if 'Esc' (27) is pressed and the overlay is currently open
		if (e.keyCode == 27 && this.isOverlayOpen) {
			this.closeOverlay();
		}
	}

	// Function to open the search overlay
	openOverlay() {
		// Add HTML structure for search overlay
		this.addStartHTML()

		// Add classes to display the search overlay and disable body scroll
		this.searchOverlay.classList.add('search-overlay--active')
		document.body.classList.add('body-no-scroll')

		// Clear the search field and focus after a short delay
		this.searchField.value = ''
		setTimeout(() => this.searchField.focus(), 301)

		// Listen for click events outside the overlay to close it
		document.addEventListener('click', this.handleClickOutside)

		// Update overlay state to indicate it's open
		this.isOverlayOpen = true

		// Fire GTM datalayer.
		if (typeof window.dataLayer !== 'undefined') {
			window.dataLayer.push({
				event : 'search_results',
				action: 'open_search'
			});
		}
        
        console.log('search overlay opened');


		// Indicate success or a specific action preventing the default behavior (returning false here)
		return false;
	}

    switchTab() {
		// Attach click event listener to tab buttons
		Array.from((this.tabButtons = document.querySelectorAll('.tab-btn'))).forEach(button => {
			button.addEventListener('click', e => {
				// Remove active class from all buttons
				this.tabButtons.forEach(button => {
					button.classList.remove('active')
				})

				// Add active class to the clicked button
				if (e.target.classList.contains('active')) {
					e.target.classList.remove('active')
				} else {
					e.target.classList.add('active')
				}

				// Open the tab panel if the panel id matches the button data-id
				Array.from((this.tabPanels = document.querySelectorAll('.tab-panel'))).forEach(panel => {
					panel.classList.remove('open')
					if (panel.id === e.target.dataset.id) {
						panel.classList.add('open')
					}

                    this.panels = document.getElementById('panels')
                    // this.panels.scrollIntoView({ behavior: 'smooth' })
				})
			})
		})
	}

	// Function to close the search overlay
	closeOverlay() {
		// Remove classes to hide the search overlay and enable body scroll
		this.searchOverlay.classList.remove('search-overlay--active')
		document.body.classList.remove('body-no-scroll')

		// Remove event listener for clicks outside the overlay
		document.removeEventListener('click', this.handleClickOutside)

		// Update overlay state to indicate it's closed
		this.isOverlayOpen = false

		// Clear the search results container when the overlay is closed
		this.resultsDiv.innerHTML = ''

        console.log('search overlay closed');
	}

	// Function to add HTML structure for search overlay
	addSearchHTML() {
		// Insert the search overlay HTML at the end of the body
		document.body.insertAdjacentHTML(
			'beforeend',
			`
            <div class="search-overlay">
                <div class="search-overlay__wrapper">
                    <div class="search-overlay__top">
                        <div class="search-overlay__top__wrapper">
                            <input type="text" class="search-term" placeholder="${drlRoot.translations.input_placeholder}" id="search-term">
                            <div class="spinner-container">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/></svg>
                            </div>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="search-overlay__close" width="30" height="30" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/></svg>
                    </div>
                    <div class="search-overlay__bottom">
                        <div class="search-overlay__results" id="search-overlay__results"></div>
                    </div>
                </div>
            </div>
            `
		)
	}

	// Function to add initial HTML structure for search overlay
	addStartHTML() {
		// Find the results div element
		this.resultsDiv = document.getElementById('search-overlay__results');

		// If results div is not found, log an error and return
		if (!this.resultsDiv) {
			return;
		}

		// Populate the results div with HTML content
		this.resultsDiv.innerHTML = `
            <div class="tabset">
                <div class="tab-panels">
                    <section id="all" class="tab-panel open">
                        <div class="tab-panel__wrapper">
                            <div class="tab-panel__left">
                                <h2>${this.translations.products}</h2>
                                ${drlRoot.start_products.products.length ? '<ul class="link-list products">' : ''}
                                    ${drlRoot.start_products.products.map(product => `
                                    <li>
                                        <div class="product ${product.type}">
                                            <div class="product__left">  
                                                ${(product.discount_label_big ?? product.discount_label_small) ? `<div class="sale-label"><span class="top">${product.discount_label_big}</span><span class="bottom">${product.discount_label_small}</span></div>` : ''}
                                                <a href="${product.permalink}" class="img">
                                                    <img src="${product.image}" alt="${product.title}">
                                                </a>
                                            </div>
                                            <div class="product__middle">
                                                <div class="content">
                                                    <a href="${product.permalink}" class="title">${product.title}</a>
                                                    <p class="content__excerpt">${product.excerpt}</p>
                                                    <p>${product.in_stock ? `<span style="color:#006980;">${this.translations.in_stock}</span>` : `<span style="color:#F8485E;">${this.translations.out_of_stock}`}</span></p>
                                                    <p class="price">${product.price}</p>
                                                </div>
                                            </div>
                                            <div class="product__right">
                                                <div class="content">
                                                    ${product.in_stock ?
                                                        (product.type == 'variable' ?
                                                                `<a href="${product.permalink}" class="button add_to_cart_button ${product.type}" data-product_id="${product.id}" data-product_sku="${product.sku}" aria-label="Go to '${product.title}'" rel="nofollow" title="${this.translations.view_products}"><span class="add-now">${this.translations.view_options}</span></a>` :
                                                                `<button data-quantity="1" class="button add_to_cart_button product_type_simple ajax_add_to_cart" data-product_id="${product.id}" data-product_sku="${product.sku}" title="${this.translations.add_to_cart}"><span class="add-now" data-add="${this.translations.add_to_cart}" data-added="${this.translations.added}"></span></button>`
                                                        ) :
                                                        `<a href="${product.permalink}" class="button add_to_cart_button sold-out waitlist ${product.type}" data-product_id="${product.id}" data-product_sku="${product.sku}" aria-label="Go to '${product.title}'" rel="nofollow" title="${this.translations.waitlist}"><span class="add-now">${this.translations.waitlist}</span></a>`
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </li>`).join('')}
                                ${drlRoot.start_products.products.length ? '</ul>' : ''}
                            </div>
                            <div class="tab-panel__right">
                                <h2>${this.translations.categories}</h2>
                                <ul class="link-list min-list">
                                    ${drlRoot.start_product_cats.product_cats.slice(0, 5).map(cat => `
                                        <li><a href="${cat.permalink}">${cat.title}</a></li>
                                    `).join('')}
                                </ul>
                                <hr>
                                <h2>${this.translations.advice}</h2>
                                <ul class="link-list min-list">
                                    ${drlRoot.start_advices.advices.slice(0, 5).map(advice => `
                                        <li><a href="${advice.permalink}">${advice.title}</a></li>
                                    `).join('')}
                                </ul>
                            </div>
                        </div>
                    </section>
                    <section id="advice" class="tab-panel">
                        <h2>${this.translations.advice}</h2>
                        <ul class="link-list">
                        ${drlRoot.start_advices.advices.map(advice => `
                            <li>                        
                                <div class="post">
                                    <div class="post__left">
                                        <a href="${advice.permalink}" class="img">
                                            <img src="${advice.image}" alt="${advice.title}">
                                        </a>
                                    </div>
                                    <div class="post__right">
                                        <div class="content">
                                            <a href="${drlRoot.root_url}/advies/alles-over-acne/" class="title">${advice.title}</a>
                                            <p>${advice.excerpt}</p>
                                            <a href="${advice.permalink}">${this.translations.read_more}</a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        `).join('')}
                    </ul>
                    </section>
                </div>
            </div>
        `;

        // Attach click event listener to tab buttons
		this.switchTab()
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new Search()
})
